export default __webpack_public_path__ + "static/negx-f5cdcf1742a73ed1ec158c0ce1818006.jpg";